import { defineAction } from '~/prix'
import { z } from 'zod'
import fetchDistinctLegalEntitiesEmissorNfeSizeAction from './distinctLegalEntitiesEmissorNfeSize.action.json'
import { point, polygon } from '~/prix/zodTypes/presets/geo'
import expression from '~/prix/zodTypes/expression'

const dateString = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Data deve estar no formato yyyy-MM-dd')

const finiteNumber = z.number().finite()

const boundsSchema = z
  .object({
    west: finiteNumber,
    south: finiteNumber,
    east: finiteNumber,
    north: finiteNumber,
  })
  .refine(bounds => bounds.west < bounds.east && bounds.south < bounds.north, {
    message: 'Limites do mapa inválidos',
  })

const timeSchema = z
  .object({
    type: z.string().nullish(),
    title: z.string().nullish(),
    startDate: dateString.nullish(),
    endDate: dateString.nullish(),
    groupType: z.string().nullish(),
  })
  .refine(time => !time.startDate || !time.endDate || time.startDate <= time.endDate, {
    message: 'A data inicial não pode ser maior que a data final',
    path: ['startDate'],
  })

const nullableString = z.union([z.string(), z.number()]).transform(String).nullish()
const emissorFilterableShape = z.object({
  ageGroup: z.string().nullish(),
  segmentId: z.string().nullish(),
  registrationStatus: z.string().nullish(),
})
export const emissorFilterSchema = expression(emissorFilterableShape.shape)

const inputSchema = z.object({
  bounds: boundsSchema.nullish(),
  zoom: finiteNumber.min(0).max(24).nullish(),
  time: timeSchema.nullish(),
  filter: emissorFilterSchema.nullish(),
})

const outputSchema = z.object({
  items: z.array(
    z.object({
      h3: z.string(),
      size: z.string(),
      weight: z.number(),
      coordinates: point(),
      id: nullableString,
      cnpj: nullableString,
      tradeName: nullableString,
      corporateName: nullableString,
      openingDate: nullableString,
      ageGroup: nullableString,
      mainCnaeId: nullableString,
      cnaeDescription: nullableString,
      segmentId: nullableString,
      segmentDescription: nullableString,
    }),
  ),
  metadata: z.object({
    grids: z.array(
      z.object({
        id: z.number(),
        bounds: polygon(),
        h3Resolution: z.number(),
        shouldCluster: z.boolean(),
      }),
    ),
    gridSize: z.number().nullish(),
    h3Resolution: z.number().nullish(),
    shouldCluster: z.boolean().nullish(),
    zoomRange: z
      .object({
        min: z.number(),
        max: z.number(),
      })
      .nullish(),
    startDate: dateString.nullish(),
    endDate: dateString.nullish(),
    latestSyncTimestamp: z.string().nullish(),
    truncated: z.boolean().nullish(),
  }),
})

export type FetchDistinctLegalEntitiesEmissorNfeSizeInput = z.infer<typeof inputSchema>

const fetchDistinctLegalEntitiesEmissorNfeSizeDefinition = defineAction({
  ...fetchDistinctLegalEntitiesEmissorNfeSizeAction,
  input: inputSchema as any,
  output: outputSchema as any,
})

export default fetchDistinctLegalEntitiesEmissorNfeSizeDefinition
